import { DraftEmail } from "@zickko/shared/src/models/DraftEmail";
import { DraftsEmailListItemWidget } from "./DraftsEmailListItemWidget";

type Props = {
  emailList: DraftEmail[];
  onSelectEmail: (email) => void;
};

export const DraftsEmailListWidget = (props: Props) => {
  return (
    <div className="list-container">
      {props.emailList.length === 0 ? (
        <div className="no-emails-message">No drafts available.</div>
      ) : (
        props.emailList.map((email) => (
          <DraftsEmailListItemWidget email={email} key={email.id} onSelectEmail={() => props.onSelectEmail(email)} />
        ))
      )}
    </div>
  );
};
